import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import { questionProps } from "lib/propTypes";

import Textarea from "./QuestionTextarea";
import QuestionButtonGroup from "./QuestionButtonGroup";

function ShortAnswerQuestion(
    { id, handleAnswer, readOnly, question, multiline, handleSkip, isLastQuestion },
    { t: _ },
) {
    const [hasError, setHasError] = useState(false);
    const [hasInput, setHasInput] = useState(false);
    const input = useRef();

    useEffect(() => {
        if (hasError) {
            input.current.focus();
        }
    }, [hasError]);

    function checkResponse() {
        const response = input.current.value.trim();
        setHasError(response.length === 0);
        setHasInput(response.length > 0);
        return response;
    }

    function onSubmit(event) {
        event.preventDefault();

        const response = checkResponse();
        if (!response) {
            return;
        }

        handleAnswer({
            questionID: id,
            response,
        });
    }

    return (
        <div>
            <label className="questions__title">{question}</label>
            <Textarea
                onChange={() => checkResponse()}
                placeholder={_("Let us know how we can improve")}
                ref={input}
                disabled={readOnly}
                multiline={multiline}
                data-test="further-feedback-text-area"
            />
            {!readOnly && (
                <QuestionButtonGroup
                    handleSkip={handleSkip}
                    handleSubmit={onSubmit}
                    nextDisabled={!hasInput}
                    isLastQuestion={isLastQuestion}
                />
            )}
        </div>
    );
}

ShortAnswerQuestion.contextTypes = {
    t: PropTypes.func,
};

ShortAnswerQuestion.propTypes = {
    ...questionProps,
    handleAnswer: PropTypes.func.isRequired,
    handleSkip: PropTypes.func.isRequired,
    readOnly: PropTypes.bool.isRequired,
    multiline: PropTypes.bool,
    isLastQuestion: PropTypes.bool,
};

ShortAnswerQuestion.defaultProps = {
    multiline: false,
    isLastQuestion: false,
};

export default React.memo(ShortAnswerQuestion);
